import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./MDPatientSheet.module.less";
import classNames from "classnames";
class MDPatientSheet extends Component {
    render() {
        const { props } = this;
        if (props.locale === "en") {
            return (<div className={classNames("vr", "vr_x2", { [styles.padTop]: props.padTop === true }, props.addlStyles)}>
					<a className={styles.link} href={`/download/document/patient/${props.clientId}`}>
						<span>View the {props.clientName} MD Patient Information sheet</span>
					</a>
				</div>);
        }
        else if (props.locale === "es" && props.hasSpanish) {
            return (<div className={classNames("vr", "vr_x2", { [styles.padTop]: props.padTop === true }, props.addlStyles)}>
					<a className={styles.link} href={`/download/document/patientES/${props.clientId}`}>
						<span>Vea la hoja de información para el paciente de Maryland {props.clientName}</span>
					</a>
				</div>);
        }
    }
}
const mapStateToProps = (state) => ({
    locale: state.i18n.locale
});
export default connect(mapStateToProps)(MDPatientSheet);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/MDPatientSheet/MDPatientSheet.tsx